module.exports = __webpack_public_path__ + "static/media/Niveau_elN10_0_115400.c3a90ac3.png";